import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';

export interface AccessPerson {
  gmid: string;
  email?: string | null;
}

export interface AccessUser extends AccessPerson {
  id: number;
  userRole: string;
  email?: string | null;
  added_by_gmid?: string | null;
  isActive: boolean | number;
  createdAt?: string;
  updatedAt?: string;
}

export interface AccessUserUpdate {
  id: number;
  gmid: string;
  userRole: string;
  email: string | null;
  isActive: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class AccessControlService {
  private readonly url = `${environment.apiConfig.baseUrl}/enac/user-roles`;

  constructor(private readonly http: HttpClient) {}

  getAccessUsers(): Observable<AccessUser[]> {
    return this.http.get<AccessUser[] | { users?: AccessUser[] }>(this.url).pipe(
      map(response => Array.isArray(response) ? response : response?.users ?? [])
    );
  }

  addAccessUsers(people: AccessPerson[]): Observable<unknown> {
    const users = people.map(person => ({
      gmid: person.gmid,
      email: person.email ?? null,
      userRole: 'access'
    }));

    return this.http.post<unknown>(this.url, { users });
  }

  updateAccessUsers(users: AccessUserUpdate[]): Observable<unknown> {
    return this.http.put<unknown>(this.url, { users });
  }

  deleteAccessUsers(ids: number[]): Observable<unknown> {
    return this.http.delete<unknown>(this.url, { body: { ids } });
  }
}
